
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import UI from 'photoswipe/dist/photoswipe-ui-default'
import objectAssign from 'object-assign'
import Toast from 'vux/src/components/toast/index.vue'

import $ from 'jquery'

export default {
name: 'previewer',
computed: {
imgs() {
return this.list.map(one => {
if (!one.msrc) {
one.msrc = one.src
}
if (typeof one.w === 'undefined') {
one.w = 0
one.h = 0
}
return one
})
},
totalNum() {
return this.$store.state.live.detail.PublishPicturesCount
}
},
data() {
return {
pic_size: 0,
pic_title: '',
pic_time: '',
total: 0,
isLoading: false,
isOrigin: false,
current: 0,
showPositionValue: false,
position: 'default'
}
},
components: {
Toast
},
methods: {
init(index) {
const self = this
const showItem = this.imgs[index]
this._init(index)
},
_init(index) {
const self = this
let options = objectAssign(
{
history: false,
shareEl: false,
tapToClose: true,
index: index
},
this.options
)
this.photoswipe = new PhotoSwipe(this.$el, UI, this.imgs, options)
this.photoswipe.init()
this.photoswipe.listen('close', () => {
this.$emit('on-close')
})

var _this = this
let pw = this.photoswipe
this.photoswipe.listen('afterChange', function() {
_this.pic_time = this.currItem.info.OriginalAt.replace(/T/, ' ')
_this.pic_title = this.currItem.info.Title
_this.pic_size = parseInt(this.currItem.info.Size / 1024)
_this.isOrigin = this.currItem.isOrigin
_this.total = _this.totalNum
_this.current = this.getCurrentIndex() + 1
// 如果读到最后一张图，应该继续加载图片列表，并重绘页面
if (
_this.current >= this.items.length - 5 &&
_this.current < _this.total
) {
_this.loadMore()
// setTimeout(function () {
//   pw.invalidateCurrItems()
//   pw.updateSize(true)
// }, 3000)
setTimeout(() => {
_this.imgs.map((item, index) => {
if (index > pw.items.length) {
pw.items.push(item)
}
})
pw.updateSize(true)
}, 1000)
}
})
this.photoswipe.listen('gettingData', function(index, item) {
_this.pic_time = this.currItem.info.OriginalAt.replace(/T/, ' ')
_this.pic_title = this.currItem.info.Title
_this.pic_size = parseInt(this.currItem.info.Size / 1024)
_this.total = _this.totalNum
_this.isOrigin = this.currItem.isOrigin
_this.current = this.getCurrentIndex() + 1
})
},
showPosition(position) {
this.position = position
this.showPositionValue = true
},
show(index) {
this.init(index)
},
showOrigin(index) {
this.isLoading = true
this.imgs[index - 1].src = this.imgs[index - 1].origin_url
this.imgs[index - 1].isOrigin = true

this.photoswipe.invalidateCurrItems()
this.photoswipe.updateSize(true)
let _this = this
var timer = setInterval(() => {
// console.log('====', $(this.photoswipe.currItem.container.childNodes[1]))
if ($(this.photoswipe.currItem.container.childNodes[1])[0]) {
if ($(this.photoswipe.currItem.container.childNodes[1])[0].complete) {
clearInterval(timer)
this.isLoading = false
}
}
}, 100)
// setTimeout(() => {
//   this.isLoading = false
// }, 2000)
},
close() {
this.photoswipe.close()
},
loadMore() {
this.$emit('loadMore')
}
},
props: {
list: {
type: Array,
required: true
},
index: {
type: Number,
default: 0
},
options: {
type: Object,
default() {
return {}
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Previewer/Previewer.vue